/** Track 4: notifications, seasons, rankings, alliances, galactic events (apps/api/src/routes/social.ts). */
import type {
  AllianceGoalKind, AllianceOverview, CosmeticView, GalacticEventView, HallOfFameEntry, NotificationSettingsView,
  NotificationView, RankingsView, UpdateNotificationSettings,
} from '@galaxis/shared';
import { apiFetch } from './client.ts';

const json = (method: string, body?: unknown): RequestInit => ({ method, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });

export const fetchNotifications = () => apiFetch<{ items: NotificationView[]; unread: number }>('/notifications');
export const markNotificationsRead = () => apiFetch<{ ok: true }>('/notifications/read', json('POST'));
export const fetchNotificationSettings = () => apiFetch<NotificationSettingsView>('/notifications/settings');
export const saveNotificationSettings = (patch: UpdateNotificationSettings) =>
  apiFetch<NotificationSettingsView>('/notifications/settings', json('PUT', patch));
export const subscribePush = (sub: { endpoint: string; keys: { p256dh: string; auth: string } }) =>
  apiFetch<NotificationSettingsView>('/notifications/push/subscribe', json('POST', sub));
export const unsubscribePush = (endpoint: string) =>
  apiFetch<NotificationSettingsView>('/notifications/push/unsubscribe', json('POST', { endpoint }));

export const fetchRankings = () => apiFetch<RankingsView>('/rankings');
export const fetchHallOfFame = () => apiFetch<{ entries: HallOfFameEntry[] }>('/hall-of-fame');
export const fetchCosmetics = () => apiFetch<{ items: CosmeticView[] }>('/cosmetics');
export const equipCosmetic = (key: string | null) => apiFetch<{ items: CosmeticView[] }>('/cosmetics/equipped', json('PUT', { key }));

export const fetchAlliance = () => apiFetch<AllianceOverview>('/alliance');
export const createAlliance = (name: string, tag: string) => apiFetch<{ id: string }>('/alliance', json('POST', { name, tag }));
export const inviteToAlliance = (targetCivId: string) => apiFetch<{ id: string }>('/alliance/invites', json('POST', { targetCivId }));
export const respondAllianceInvite = (id: string, accept: boolean) =>
  apiFetch<{ ok: true }>(`/alliance/invites/${id}/${accept ? 'accept' : 'reject'}`, json('POST'));
export const leaveAlliance = () => apiFetch<{ ok: true }>('/alliance/leave', json('POST'));
export const createAllianceGoal = (kind: AllianceGoalKind, target: number) => apiFetch<{ id: string }>('/alliance/goals', json('POST', { kind, target }));
export const saveAllianceWebhook = (discordWebhookUrl: string, discordEnabled = true) =>
  apiFetch<{ ok: true }>('/alliance/discord', json('PUT', { discordWebhookUrl, discordEnabled }));

export const fetchGalacticEvents = () => apiFetch<{ events: GalacticEventView[] }>('/galactic-events');
export const decideGalacticEvent = (id: string, optionKey: string) =>
  apiFetch<{ ok: true }>(`/galactic-events/${id}/decide`, json('POST', { optionKey }));
